import React from 'react';

// Generated from the LegalApp design canvas.
export default function CasePath({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-path-iso" viewBox="-95.1 -67.5 661.4 470.5" role="img" aria-label="Illustration: a case moving from complaint through intake, evidence and witnesses to a complete file, with missing details caught at each stop" style={style}>
    <polygon points="554.3,320.0 471.1,368.0 471.1,362.0 554.3,314.0" fill="#A9C3F3" />
    <polygon points="-83.1,48.0 471.1,368.0 471.1,362.0 -83.1,42.0" fill="#C2D4F6" />
    <polygon points="0.0,-6.0 554.3,314.0 471.1,362.0 -83.1,42.0" fill="#D9E5FB" />
    <g className="lp-iso-links">
      <line x1="-32.9" y1="23.0" x2="504.0" y2="333.0" className="lp-iso-link lp-iso-link-blue" />
    </g>
    <polygon points="97.0,58.0 27.7,98.0 27.7,93.0 97.0,53.0" fill="#BCD1F8" />
    <polygon points="-69.3,42.0 27.7,98.0 27.7,93.0 -69.3,37.0" fill="#E4EDFD" />
    <polygon points="0.0,-3.0 97.0,53.0 27.7,93.0 -69.3,37.0" fill="#FFFFFF" />
    <polygon points="207.8,122.0 138.6,162.0 138.6,157.0 207.8,117.0" fill="#BCD1F8" />
    <polygon points="41.6,106.0 138.6,162.0 138.6,157.0 41.6,101.0" fill="#E4EDFD" />
    <polygon points="110.9,61.0 207.8,117.0 138.6,157.0 41.6,101.0" fill="#FFFFFF" />
    <polygon points="318.7,186.0 249.4,226.0 249.4,221.0 318.7,181.0" fill="#BCD1F8" />
    <polygon points="152.4,170.0 249.4,226.0 249.4,221.0 152.4,165.0" fill="#E4EDFD" />
    <polygon points="221.7,125.0 318.7,181.0 249.4,221.0 152.4,165.0" fill="#FFFFFF" />
    <polygon points="429.5,250.0 360.3,290.0 360.3,285.0 429.5,245.0" fill="#BCD1F8" />
    <polygon points="263.3,234.0 360.3,290.0 360.3,285.0 263.3,229.0" fill="#E4EDFD" />
    <polygon points="332.6,189.0 429.5,245.0 360.3,285.0 263.3,229.0" fill="#FFFFFF" />
    <polygon points="540.4,314.0 471.1,354.0 471.1,349.0 540.4,309.0" fill="#BCD1F8" />
    <polygon points="374.1,298.0 471.1,354.0 471.1,349.0 374.1,293.0" fill="#E4EDFD" />
    <polygon points="443.4,253.0 540.4,309.0 471.1,349.0 374.1,293.0" fill="#FFFFFF" />
    <polygon points="39.0,36.5 -0.9,59.5 -0.9,-26.5 39.0,-49.5" fill="#0B1B3F" />
    <polygon points="-11.3,53.5 -0.9,59.5 -0.9,-26.5 -11.3,-32.5" fill="#16284D" />
    <polygon points="28.6,-55.5 39.0,-49.5 -0.9,-26.5 -11.3,-32.5" fill="#2A3D69" />
    <polygon points="35.5,30.5 2.6,49.5 2.6,-21.5 35.5,-40.5" fill="#EAF1FE" />
    <polygon points="23.4,-16.5 4.3,-5.5 4.3,-11.5 23.4,-22.5" fill="#F2A33A" />
    <polygon points="32.9,-11.0 12.1,1.0 12.1,-5.0 32.9,-17.0" fill="#2563DE" />
    <polygon points="26.8,3.5 4.3,16.5 4.3,10.5 26.8,-2.5" fill="#F2A33A" />
    <polygon points="32.0,22.5 6.1,37.5 6.1,24.5 32.0,9.5" fill="#FFFFFF" />
    <polygon points="30.3,18.5 27.7,20.0 27.7,17.0 30.3,15.5" fill="#F2A33A" />
    <polygon points="174.9,112.0 169.7,115.0 169.7,37.0 174.9,34.0" fill="#BCD1F8" />
    <polygon points="114.3,83.0 169.7,115.0 169.7,37.0 114.3,5.0" fill="#E4EDFD" />
    <polygon points="119.5,2.0 174.9,34.0 169.7,37.0 114.3,5.0" fill="#FFFFFF" />
    <polygon points="121.2,23.0 147.2,38.0 147.2,32.0 121.2,17.0" fill="#0B1B3F" />
    <polygon points="121.2,39.0 128.2,43.0 128.2,35.0 121.2,31.0" fill="#2563DE" />
    <polygon points="132.5,43.5 161.9,60.5 161.9,56.5 132.5,39.5" fill="#BCD1F8" />
    <polygon points="121.2,51.0 128.2,55.0 128.2,47.0 121.2,43.0" fill="#2563DE" />
    <polygon points="132.5,55.5 155.0,68.5 155.0,64.5 132.5,51.5" fill="#BCD1F8" />
    <polygon points="121.2,63.0 128.2,67.0 128.2,59.0 121.2,55.0" fill="#2563DE" />
    <polygon points="132.5,67.5 161.9,84.5 161.9,80.5 132.5,63.5" fill="#BCD1F8" />
    <polygon points="121.2,75.0 128.2,79.0 128.2,71.0 121.2,67.0" fill="#F2A33A" />
    <polygon points="132.5,79.5 155.0,92.5 155.0,88.5 132.5,75.5" fill="#FFE2B8" />
    <polygon points="277.1,175.0 237.3,198.0 237.3,164.0 277.1,141.0" fill="#D7861F" />
    <polygon points="192.3,172.0 237.3,198.0 237.3,164.0 192.3,138.0" fill="#F2A33A" />
    <polygon points="232.1,115.0 277.1,141.0 237.3,164.0 192.3,138.0" fill="#FFCB7E" />
    <polygon points="214.8,125.0 259.8,151.0 254.6,154.0 209.6,128.0" fill="#0B1B3F" opacity="0.85" />
    <polygon points="259.8,163.0 254.6,166.0 254.6,154.0 259.8,151.0" fill="#0B1B3F" opacity="0.85" />
    <polygon points="206.1,186.0 202.6,188.0 202.6,166.0 206.1,164.0" fill="#BCD1F8" />
    <polygon points="180.1,175.0 202.6,188.0 202.6,166.0 180.1,153.0" fill="#E4EDFD" />
    <polygon points="183.6,151.0 206.1,164.0 202.6,166.0 180.1,153.0" fill="#FFFFFF" />
    <text transform="matrix(0.8660 0.5 0 1 183.6 169.0)" className="lp-iso-tag" fill="#0B1B3F">
      {"E-1"}
    </text>
    <path d="M317.6 218.0 L317.6 194.0 L337.2 194.0 L337.2 218.0 A9.8 5.7 0 0 1 317.6 218.0 Z" fill="#A9C3F3" />
    <ellipse cx="327.4" cy="194.0" rx="9.8" ry="5.7" fill="#EEF3FE" />
    <circle cx="327.4" cy="183.2" r="7.6" fill="#EEF3FE" />
    <path d="M345.3 224.0 L345.3 200.0 L364.9 200.0 L364.9 224.0 A9.8 5.7 0 0 1 345.3 224.0 Z" fill="#1A4DB8" />
    <ellipse cx="355.1" cy="200.0" rx="9.8" ry="5.7" fill="#4C81EC" />
    <circle cx="355.1" cy="189.2" r="7.6" fill="#4C81EC" />
    <path d="M322.8 243.0 L322.8 219.0 L342.4 219.0 L342.4 243.0 A9.8 5.7 0 0 1 322.8 243.0 Z" fill="#D7861F" />
    <ellipse cx="332.6" cy="219.0" rx="9.8" ry="5.7" fill="#FFCB7E" />
    <circle cx="332.6" cy="208.2" r="7.6" fill="#FFCB7E" />
    <path d="M359.1 248.0 L359.1 224.0 L378.7 224.0 L378.7 248.0 A9.8 5.7 0 0 1 359.1 248.0 Z" fill="#1A4DB8" />
    <ellipse cx="368.9" cy="224.0" rx="9.8" ry="5.7" fill="#4C81EC" />
    <circle cx="368.9" cy="213.2" r="7.6" fill="#4C81EC" />
    <polygon points="523.1,305.0 469.4,336.0 469.4,333.0 523.1,302.0" fill="#BCD1F8" />
    <polygon points="401.8,297.0 469.4,336.0 469.4,333.0 401.8,294.0" fill="#E4EDFD" />
    <polygon points="455.5,263.0 523.1,302.0 469.4,333.0 401.8,294.0" fill="#FFFFFF" />
    <polygon points="517.9,303.0 462.5,335.0 462.5,332.0 517.9,300.0" fill="#DCE6FB" />
    <polygon points="393.2,295.0 462.5,335.0 462.5,332.0 393.2,292.0" fill="#F1F5FE" />
    <polygon points="448.6,260.0 517.9,300.0 462.5,332.0 393.2,292.0" fill="#FFFFFF" />
    <polygon points="517.9,302.0 460.7,335.0 460.7,327.0 517.9,294.0" fill="#1A4DB8" />
    <polygon points="388.0,293.0 460.7,335.0 460.7,327.0 388.0,285.0" fill="#2563DE" />
    <polygon points="445.1,252.0 517.9,294.0 460.7,327.0 388.0,285.0" fill="#4C81EC" />
    <polygon points="518.7,295.5 512.7,299.0 512.7,291.0 518.7,287.5" fill="#1A4DB8" />
    <polygon points="493.6,288.0 512.7,299.0 512.7,291.0 493.6,280.0" fill="#2563DE" />
    <polygon points="499.7,276.5 518.7,287.5 512.7,291.0 493.6,280.0" fill="#4C81EC" />
    <polygon points="445.1,266.0 481.5,287.0 448.6,306.0 412.2,285.0" fill="#FFFFFF" />
    <text transform="matrix(0.8660 -0.5 0.8660 0.5 427.0 289.5)" className="lp-iso-label" fill="#0B1B3F">
      {"CASE"}
    </text>
    <text transform="matrix(0.8660 -0.5 0.8660 0.5 437.3 295.5)" className="lp-iso-label" fill="#0B1B3F">
      {"FILE"}
    </text>
    <polygon points="466.8,284.5 470.3,286.5 451.2,297.5 447.7,295.5" fill="#F2A33A" />
    <g className="lp-iso-badge lp-float-b">
      <circle cx="452.9" cy="233.5" r="19" fill="#F2A33A" />
      <circle cx="452.9" cy="233.5" r="19" fill="none" className="lp-iso-badge-ring" />
      <path d="M445.0 233.9 L451.0 240.0 L461.5 227.8" className="lp-iso-check" />
    </g>
    <g className="lp-iso-chip lp-float-a">
      <rect x="60.7" y="-29.0" width="128" height="32" rx="10" fill="#FFFFFF" className="lp-iso-chip-box" />
      <circle cx="77.7" cy="-13.0" r="8" fill="#1D5BD8" />
      <path d="M73.7 -13.0 l3 3 5.2-5.8" className="lp-iso-mini-check" />
      <text x="92.7" y="-8.2" className="lp-iso-chip-text" fill="#A85A0C">
        {"+2 details"}
      </text>
    </g>
    <g className="lp-iso-chip lp-float-b">
      <rect x="179.6" y="35.0" width="112" height="32" rx="10" fill="#FFFFFF" className="lp-iso-chip-box" />
      <circle cx="196.6" cy="51.0" r="8" fill="#1D5BD8" />
      <path d="M192.6 51.0 l3 3 5.2-5.8" className="lp-iso-mini-check" />
      <text x="211.6" y="55.8" className="lp-iso-chip-text" fill="#A85A0C">
        {"+3 items"}
      </text>
    </g>
    <g className="lp-iso-chip lp-float-a">
      <rect x="272.4" y="99.0" width="148" height="32" rx="10" fill="#FFFFFF" className="lp-iso-chip-box" />
      <circle cx="289.4" cy="115.0" r="8" fill="#1D5BD8" />
      <path d="M285.4 115.0 l3 3 5.2-5.8" className="lp-iso-mini-check" />
      <text x="304.4" y="119.8" className="lp-iso-chip-text" fill="#A85A0C">
        {"+3 witnesses"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="-68.9" y="105.0" width="104" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="-16.9" y="125.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Complaint"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="53.9" y="169.0" width="80" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="93.9" y="189.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Intake"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="156.8" y="233.0" width="96" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="204.8" y="253.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Evidence"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="263.6" y="297.0" width="104" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="315.6" y="317.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Witnesses"}
      </text>
    </g>
    <g className="lp-iso-pill">
      <rect x="358.5" y="361.0" width="136" height="30" rx="15.0" fill="#0B1B3F" />
      <text x="426.5" y="381.5" className="lp-iso-pill-text lp-iso-pill-lg" fill="#FFFFFF">
        {"Complete file"}
      </text>
    </g>
    </svg>
  );
}
